// Urgency helper — returns { level, color, bg, textColor } based on time until pickup.
// - level "red"    : < 1.5h  → destructive
// - level "orange" : < 3h    → warning
// - level ""       : >= 3h or past

export function urgencyLevel(pickupIso) {
  if (!pickupIso) return "";
  const t = new Date(pickupIso).getTime();
  if (Number.isNaN(t)) return "";
  const diffH = (t - Date.now()) / (1000 * 60 * 60);
  if (diffH < 0) return "";
  if (diffH < 1.5) return "red";
  if (diffH < 3) return "orange";
  return "";
}

export function urgencyStyle(level) {
  if (level === "red") {
    return {
      bg: "rgba(198, 40, 40, 0.10)",
      border: "#C62828",
      text: "#C62828",
      dot: "#C62828",
    };
  }
  if (level === "orange") {
    return {
      bg: "rgba(245, 127, 23, 0.10)",
      border: "#F57F17",
      text: "#F57F17",
      dot: "#F57F17",
    };
  }
  return { bg: "transparent", border: "transparent", text: "inherit", dot: "transparent" };
}

export function timeUntil(iso, fmtFn) {
  const fmt = fmtFn || ((n) => String(n));
  if (!iso) return "";
  const diffMs = new Date(iso).getTime() - Date.now();
  if (Number.isNaN(diffMs) || diffMs <= 0) return "انتهى الموعد";
  const mins = Math.floor(diffMs / 60000);
  if (mins < 60) return `بعد ${fmt(mins)} دقيقة`;
  const hours = Math.floor(mins / 60);
  const rem = mins % 60;
  if (hours < 24) return `بعد ${fmt(hours)}س ${fmt(rem)}د`;
  const days = Math.floor(hours / 24);
  return `بعد ${fmt(days)} يوم`;
}
